const TECHNICAL_ERROR_PATTERNS = [
  /SQLSTATE/i,
  /PDOException/i,
  /invalid input syntax/i,
  /unnamed portal parameter/i,
  /Connection:\s*pgsql/i,
  /could not translate host name/i,
  /syntax error at or near/i,
  /Stack trace:/i,
];

/**
 * Returns a user-safe API error message, or null when the raw text should not be shown.
 */
export const sanitizeApiErrorMessage = (message) => {
  if (!message || typeof message !== "string") {
    return null;
  }

  const trimmed = message.trim();
  if (!trimmed) {
    return null;
  }

  if (TECHNICAL_ERROR_PATTERNS.some((pattern) => pattern.test(trimmed))) {
    return null;
  }

  if (trimmed.length > 280) {
    return null;
  }

  return trimmed;
};

/**
 * Extract a safe message from an axios-style API error.
 */
export const getApiErrorMessage = (error, fallback = "Something went wrong. Please try again.") => {
  return sanitizeApiErrorMessage(error?.response?.data?.message) ?? sanitizeApiErrorMessage(error?.response?.data?.error) ?? fallback;
};

export default getApiErrorMessage;
